import type { SiteSettings } from '@lambda/shared/types';
import { DEFAULT_REGISTRATION_CLOSED_MESSAGE } from '@lambda/shared/registrationSettings';

export { DEFAULT_REGISTRATION_CLOSED_MESSAGE };

export function isNewRegistrationAllowed(settings: SiteSettings | null | undefined): boolean {
  return settings?.allowNewRegistrations !== false;
}

export function shouldShowRegistrationClosedNotice(
  settings: SiteSettings | null | undefined
): boolean {
  return (
    !isNewRegistrationAllowed(settings) && settings?.showRegistrationClosedNotice === true
  );
}

export function registrationClosedNoticeText(
  settings: SiteSettings | null | undefined
): string {
  const trimmed = settings?.registrationClosedMessage?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_REGISTRATION_CLOSED_MESSAGE;
}
